module.exports = __webpack_public_path__ + "summernote.eot";


//////////////////
// WEBPACK FOOTER
// ./~/summernote/dist/font/summernote.eot
// module id = 1149
// module chunks = 14